(() => {
  const menus = document.querySelectorAll('[data-ginyhome-sort-menu]');

  menus.forEach((menu) => {
    const trigger = menu.querySelector('[data-sort-menu-trigger]');
    const list = menu.querySelector('[role="listbox"]');
    const nativeSelect = menu.closest('form')?.querySelector('select[name="sort_by"]');
    const options = [...menu.querySelectorAll('[data-sort-value]')];

    if (!trigger || !list || !nativeSelect) return;

    const close = (restoreFocus = false) => {
      list.hidden = true;
      trigger.setAttribute('aria-expanded', 'false');
      if (restoreFocus) trigger.focus();
    };

    const open = () => {
      list.hidden = false;
      trigger.setAttribute('aria-expanded', 'true');
    };

    trigger.addEventListener('click', () => {
      if (list.hidden) open();
      else close();
    });

    trigger.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowDown' || event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        open();
        options[0]?.focus();
      }

      if (event.key === 'Escape') close(true);
    });

    options.forEach((option) => {
      option.addEventListener('click', () => {
        nativeSelect.value = option.dataset.sortValue;
        nativeSelect.form?.submit();
      });

      option.addEventListener('keydown', (event) => {
        const index = options.indexOf(option);
        if (event.key === 'ArrowDown') {
          event.preventDefault();
          options[(index + 1) % options.length]?.focus();
        }
        if (event.key === 'ArrowUp') {
          event.preventDefault();
          options[(index - 1 + options.length) % options.length]?.focus();
        }
        if (event.key === 'Escape') {
          event.preventDefault();
          close(true);
        }
      });
    });

    document.addEventListener('click', (event) => {
      if (!menu.contains(event.target)) close();
    });
  });
})();
